rdefine('app/formular/components/BaseFormEl',['backbone'],function(Backbone){
    return Backbone.Ribs.View.extend({
        tagName:'div',
        className:'phone-element',
        initialize:function() {
            this.$el.attr("draggable", "true");
            this.$el.bind("dragstart", _.bind(this._dragStartEvent, this));
            this.$el.bind("dragend", _.bind(this._dragStop,this));
        },
        _dragStartEvent: function (e) {
            if (e.originalEvent) e = e.originalEvent;
            e.dataTransfer.effectAllowed = "copy";
            var data = this.dragStart(e.dataTransfer, e);

            window._backboneDragDropObject = null;
            if (data !== undefined) {
                window._backboneDragDropObject = data // we cant bind an object directly because it has to be a string, json just won't do
            }
        },

        dragStart: function (dataTransfer, e) {
           // console.log("Drag start",dataTransfer,e);
            this.collection.ebus.trigger("dragstart");
            return {o:this.model,type:'n'};
        },
        _dragStop:function() {
            //console.log("drag stop");
            this.collection.ebus.trigger("dragstop");
        }
    });
});